import { Box, Spinner } from '@factorialco/deprecated-design-system'

export const LoadingWithSpinner = () => {
  return (
    <Box padding="s40" width="full" alignItems="center" flexGrow>
      <Spinner />
    </Box>
  )
}
